import { fetchAndSetFounderDocuments } from 'components/views/FounderVault/_helpers/founderVault.resolvers';
import useEffectAsync from 'utils/useEffectAsync';
import { $list, $view } from 'signals/global.signals';
import SimpleCard from 'components/global/SimpleCard';
import FileExplorer from 'components/global/FileExplorer/FileExplorer';
import FounderDocumentsUploadModal from 'components/views/FounderVault/_components/FounderDocumentsUploadModal';
import { handleShowModal } from 'components/global/_helpers/global.helpers';
import FounderDocumentsEditModal from 'components/views/FounderVault/_components/FounderDocumentsEditModal';
import FounderDocumentsDeleteModal from 'components/views/FounderVault/_components/FounderDocumentsDeleteModal';
import FounderFolderEditModal from 'components/views/FounderVault/_components/FounderFolderEditModal';
import FounderFolderDeleteModal from 'components/views/FounderVault/_components/FounderFolderDeleteModal';
import FounderFolderCreateModal from './FounderCreateFolderModal';

const FounderDocuments = () => {
  useEffectAsync(fetchAndSetFounderDocuments);
  
  return (
    <>
      <SimpleCard>
        <FileExplorer
          initialExpandedFolders={$view.value.expandedFolders || {}}
          isLoading={$view.value.isLoading}
          folders={$list.value?.data || []}
          onUploadClick={() => handleShowModal('founder-document-upload')}
          onClickDeleteFolder={(folder) => {
            handleShowModal('founder-folder-delete', folder);
          }}
          onClickEditDocument={(document) => {
            $view.update({
              fileName: document.name,
            });
            handleShowModal('founder-document-edit', {
              ...document,
              folder: $view.value?.folderOptions.find(option => option.value === document.folderId),
            });
          }}
          onClickEditFolder={(folder) => {
            handleShowModal('founder-folder-edit', { ...folder });
          }}
          onClickViewDocument={(document) => {
            window.open(document.url, '_blank');
          }}
          onClickDeleteDocument={(document) => {
            handleShowModal('founder-document-delete', {
              ...document,
            });
          }}
          onClickCreateFolder={() => handleShowModal('founder-folder-create')}
        />
      </SimpleCard>
      <FounderDocumentsUploadModal />
      <FounderDocumentsEditModal />
      <FounderDocumentsDeleteModal />
      <FounderFolderEditModal />
      <FounderFolderDeleteModal />
      <FounderFolderCreateModal />
    </>
  );
};

export default FounderDocuments;
